import SampleReportCard from "./sampleReportCard";

export default SampleReportCard;